import * as React from 'react';
import { Separator } from '@ui/components';
import { Icon } from 'antd';
import './StoresPanel.less';

interface Props {
  region: any;
  city: any;
}

const StoresPanel: React.FunctionComponent<Props> = ({ region, city }) => (
  <div className="stores-panel">
    <div className="stores-panel__info">
      <Icon type="environment" theme="filled" style={{ padding: '0 8px' }} />
      <div>{region.name} область.</div>
      <Separator />
      <div>{city.name}</div>
    </div>
  </div>
);

export default StoresPanel;



// WEBPACK FOOTER //
// ./src/scenes/Stores/components/StoresPanel/StoresPanel.tsx